"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lock = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const react_1 = __importDefault(require("react"));
const lock_1 = __importDefault(require("../icons-path/lock"));
const icons_svg_1 = require("../icons-svg");
require("../icons.types");
const Lock = (_a) => {
    var _b;
    var { viewBox } = _a, props = __rest(_a, ["viewBox"]);
    const theme = (0, theme_1.useTheme)();
    const themeIcon = (_b = theme === null || theme === void 0 ? void 0 : theme.icons) === null || _b === void 0 ? void 0 : _b['lock'];
    return (react_1.default.createElement(icons_svg_1.IconsSvg, Object.assign({}, props, { path: themeIcon ? react_1.default.createElement(react_1.default.Fragment, null, (0, html_react_parser_1.default)(themeIcon)) : lock_1.default, viewBox: viewBox || '0 0 24 24' })));
};
exports.Lock = Lock;
